export default "__VITE_ASSET__1PLveeI2__"